import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Fieldlinks } from '../../../../../../../core/entities/fieldlinks.model';
import { FieldlinksService } from '../../../../../../../core/repositories/fieldlinks.service'
import { BASE_HREF, ICON_OPTIONS } from 'src/app/core/utils/constants';

@Injectable()
export class EditDialogsFieldlinksService {

  fieldlinks: Fieldlinks = new Fieldlinks();
  originalFieldlinks: Fieldlinks = new Fieldlinks();
  parametersInput: Fieldlinks = new Fieldlinks();

  allFieldlinks: Fieldlinks[] = [];
  iconsOption: any[] = ICON_OPTIONS;
  changetitulo: boolean = false;
  checkedOption: Boolean = true;

  constructor(private fieldlinksService: FieldlinksService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.fieldlinks = data.fieldlink;
    this.changetitulo = data.titulochange;
    this.originalFieldlinks = _.cloneDeep(this.fieldlinks);
    console.log(data);
    return this.fieldlinksService.findAll().pipe(map((result: Fieldlinks[]) => {
      this.allFieldlinks = result;
      if (Utils.noUndfAndNull(data.fieldlink)) {
        this.fieldlinks = _.cloneDeep(data.fieldlink);
      }
      return true;
    }));
  }


  /**
  * @description
  * Guarda el fieldlink
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.fieldlinks.id, "")) {

      /*comparamos el fieldlink original con el modificado*/
      let compareFieldlink = this.compare(this.fieldlinks, this.originalFieldlinks);

      if(compareFieldlink){
        return of(-1);
      }else{
        return this.fieldlinksService.postFieldlink(this.fieldlinks);
      }

    }else{
      return this.fieldlinksService.postFieldlink(this.fieldlinks);
    }
  }

  /**
  * @description
  * Comprueba si dos Fieldlinks son iguales.
  * @param datoX Fieldlink 1
  * @param datoY Fieldlink 2
  * @returns True si son iguales
  */
  public compare(itemX:Fieldlinks, itemY:Fieldlinks):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if(itemY.id == null){
        if (itemX.code !== "")
          return false;
      }else{
        if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
        || !Utils.compareTextOrNumber(itemX.description, itemY.description)
        || !Utils.compareTextOrNumber(itemX.ymlkey, itemY.ymlkey)
        || !Utils.compareTextOrNumber(itemX.icon, itemY.icon)
        || !Utils.compareTextOrNumber(itemX.url, itemY.url)
        ) && (itemX.code !== ""))
          return false;
      }
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * recogemos el valor del iciono seleccionado y lo vamos a buscar a los assets para mostralo
  */
  public seleccionIcono(): String{
    if(this.fieldlinks.icon != ''){
      return BASE_HREF + '/assets/images/icons/' + this.fieldlinks.icon + '.svg';
    }
    return "";
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.fieldlinks = new Fieldlinks();
  }

}
